import actionCreatorFactory from 'typescript-fsa';

/** テストグループ */
export interface IGroup {
	groupTitle: string;
	questions: IQuestion[];
}

/** テスト問題 */
export interface IQuestion {
	questionKind: QuestionKind;
	questionNo: string;
	questionText: string;
	imageFilePath: string;
	questionScore: string;
	questionID: string;
	questionTextNum: boolean;
	references: IReference[];
	answers: IAnswers;
	checked: boolean;
}

/** テスト形式 */
export enum QuestionKind {
	RADIO,
	TEXT,
	CHECK,
	SELECT,
}

/** 参照ファイル情報 */
export interface IReference {
	displayFileName: string;
	fileNum: number;
}

/** テスト回答リスト */
export type IAnswers =
	| IRadioAnswer[]
	| ITextAnswer[]
	| ICheckAnswer[]
	| ISelectAnswer[];

/** ラジオボタン形式回答 */
export interface IRadioAnswer {
	displayNum: string;
	options: IRadioOption[];
	selectedAnswerID: string | null;
}

/** ラジオボタン形式選択肢 */
export interface IRadioOption {
	answerText: string;
	answerID: string;
}

/** テキスト記述形式回答 */
export interface ITextAnswer {
	answerID: string;
	displayNum: string;
	answerText: string;
}

/** チェックボックス形式回答 */
export interface ICheckAnswer {
	answerText: string;
	answerID: string;
	selected: boolean;
}

/** プルダウン選択形式回答 */
export interface ISelectAnswer {
	displayNum: string;
	options: ISelectOption[];
	selectedAnswerID: string | null;
}

/** プルダウン選択形式選択肢 */
export interface ISelectOption {
	answerText: string;
	answerID: string;
}

/** テスト問題文/解説情報 */
export interface ILinkUrl {
	careerID: string;
	preview: boolean;
	lang: string;
	testID: string | null;
}

const actionCreator = actionCreatorFactory();

/** eラーニングテストパラメータ設定アクションクリエータ */
export const setTestFormParams = actionCreator<{
	timeLimit: number;
	retries: number;
	testSetQuizCount: number;
	startTime: string;
	examStartTime: string;
	thistoryID: number;
	displayTmpSaveBtn: boolean;
	groups: IGroup[];
	markAfter: boolean;
	dbms: string | null;
	cnt: number;
	questionGroupDisplay: boolean;
	groupCount: number;
}>('SET_TEST_FORM_PARAMS');

/** eラーニングテストパラメータ初期化アクションクリエータ */
export const clearTestFormParams = actionCreator<{}>('CLEAR_TEST_FORM_PARAMS');



// WEBPACK FOOTER //
// ./src/actions/testForm.ts